<template>

    <div class="nav-tabs-custom">
        <div class="tab-content">
            <div class="tab-pane active">
                <projects-server-table
                    v-if="loaded"
                    :add-url="route('projects.add', {}, false)"
                    :project-statuses="JSON.stringify(st.statuses)"
                    :teams="JSON.stringify(st.teams)"
                    :data-url="st.url"
                    :data-columns="JSON.stringify(st.columns)"
                    :preference-url="st.preferenceUrl"
                ></projects-server-table>
            </div>
        </div>
    </div>

</template>

<script>

    import ProjectsServerTable from "../../components/Projects/ProjectsServerTable";
    import axios from "axios";

    export default {

        components: {
            ProjectsServerTable,
        },

        data() {
            return {
                loaded:false,
                st: {
                    statuses:[],
                    teams:[],
                    columns:[],
                    url:'',
                    preferenceUrl:'',
                }
            }
        },

        metaInfo: {
            title:'Projects',
        },

        methods: {
            getProjectsData() {
                axios.get(this.route('api.v1.projects.st'))
                .then(resp => {
                    this.st = resp.data;
                    this.loaded = true;
                })
            }
        },

        mounted() {
            this.getProjectsData();
        },

        name:'ProjectsIndex',

    }

</script>
